export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/arrow-icon.2e69828c.svg","height":12,"width":22};